import { useCallback } from "react";
import EXTERNAL_USER_CONTRACT_ROLES from "../../types/enums/ExternalUserContractRole";

export const useGetContractRole = () => {
  const getContractRole = useCallback((contractGeneralInfo: any) => {
    if (contractGeneralInfo) {
      const role: EXTERNAL_USER_CONTRACT_ROLES = contractGeneralInfo.role;

      const isPrimary: boolean =
        role === EXTERNAL_USER_CONTRACT_ROLES.PrimaryBuyer ||
        role === EXTERNAL_USER_CONTRACT_ROLES.PrimarySeller;

      const isSecondary: boolean =
        role === EXTERNAL_USER_CONTRACT_ROLES.SecondaryBuyer ||
        role === EXTERNAL_USER_CONTRACT_ROLES.SecondarySeller;

      const isBuyer: boolean =
        role === EXTERNAL_USER_CONTRACT_ROLES.PrimaryBuyer ||
        role === EXTERNAL_USER_CONTRACT_ROLES.SecondaryBuyer;

      const isSeller: boolean =
        role === EXTERNAL_USER_CONTRACT_ROLES.PrimarySeller ||
        role === EXTERNAL_USER_CONTRACT_ROLES.SecondarySeller;

      return { role, isPrimary, isSecondary, isBuyer, isSeller };
    }

    return {
      role: undefined,
      isPrimary: false,
      isSecondary: false,
      isBuyer: false,
      isSeller: false,
    };
  }, []);

  return { getContractRole };
};
